import { FigureSettingsDto, isFigureSettingsDto } from "aic";
import axios from "axios";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";
import { SettingReadDto } from "../settings/interface";

export type IFigureTypeOptionsReturn = IAxiosReturn<FigureSettingsDto>;

/**
 * Load available figure type options from settings.
 *
 * @param backEndUrl - Base backend URL
 * @returns List of figure type option descriptors wrapped in IFigureTypeOptionsReturn
 */
export const getFigureTypeOptions = async (
  backEndUrl: string,
): Promise<IFigureTypeOptionsReturn> => {
  const url = `${backEndUrl}Settings/figureTypeOptions`;
  // Get data
  try {
    const response: { data: SettingReadDto } = await axios.get(url);
    const returnedObject = JSON.parse(response.data.value);
    // Validate returned data
    if (!isFigureSettingsDto(returnedObject)) {
      console.error("getFigureTypeOptions: returnedObject failed isFigureSettingsDto check");
      return {
        success: false,
        errorText: "Load figure type options failed: invalid data format",
      };
    }
    const returnedFigureSettings: FigureSettingsDto = returnedObject;

    // Return successful result
    return {
      success: true,
      data: returnedFigureSettings,
    };
  } catch (error: unknown) {
    console.debug("getFigureTypeOptions: caught error", error);
    return processAxiosError("Load figure type options failed", error);
  }
};
